module.exports = __webpack_public_path__ + "static/img/heard_img1.6b43e7c2.png";